// extracted by mini-css-extract-plugin
export default {"head":"heading_head__N6A0T","back":"heading_back__8JbH4"};